import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import {
  DataGridListStyle,
  DRxSelectStyle,
  greyColor,
  InputBoxStyle,
  warnColor,
} from "../../../Theme";
import { v4 as uuid } from "uuid";
import { YSButton } from "../../../uikit/YSButton";
import { useSelector } from "react-redux";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import useDebounce from "../../../CustomHooks/useDebounce";
import {
  AddToPhysicianList,
  AddToPracticeList,
  FavoriteDrugSearchWithDrugName,
} from "../../../Apis/AuthApiServices";
import NoRecords from "../../../components/NoRecords";
import ErrorOverlay from "../../../components/ErrorOverlay";
import YSSnackBar from "../../../uikit/YSSnackBar";

export default function AddNewFavDrug(props: any) {
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state?.GlobalDropdownSlice?.DropdownLists };
  }); //redux data
  const doctorId: any = localStorage.getItem("doctorId");
  const [error, setError] = useState(false);
  const [data, setData] = useState<any>([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [drugType, setDrugType] = useState("All");
  const [drugNameInput, setDrugNameInput] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const drugNameDebounceValue = useDebounce(drugNameInput, 1000);
  const [selectionData, setSelectionData] = useState<any>([]);
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const columnsAddNewFavDrug: GridColDef[] = [
    {
      field: "drugDescription",
      headerName: "Drug Description",
      width: 200,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "sig",
      headerName: "SIG",
      width: 280,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "dosageForm",
      headerName: "Qualifier",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
      type: "singleSelect",
      renderCell: ({ row }) => {
        return (
          <>
            <QualifierField row={row} />
          </>
        );
      },
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 150,
      cellClassName: "w15",
      headerClassName: "w15",

      renderCell: ({ row }) => {
        return (
          <>
            <QuantityField row={row} />
          </>
        );
      },
    },
    {
      field: "refills",
      headerName: "Refills",
      width: 150,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => {
        return (
          <>
            <RefillsField row={row} />
          </>
        );
      },
    },
  ];

  const QuantityField = (props: any) => {
    const { row } = props;
    const [quantity, setQuantity] = useState(row?.quantity ?? "");

    return (
      <TextField
        id="qty"
        label=""
        variant="outlined"
        value={quantity}
        onChange={(e: any) => {
          setQuantity(e.target.value);
          row.quantity = e.target.value;
        }}
      />
    );
  };

  const RefillsField = (props: any) => {
    const { row }: any = props;
    const [refills, setRefills] = useState(row?.refills ?? "");

    return (
      <TextField
        id="qty"
        label=""
        variant="outlined"
        value={refills}
        onChange={(e: any) => {
          setRefills(e.target.value);
          row.refills = e.target.value;
        }}
      />
    );
  };

  const QualifierField = (props: any) => {
    const { row } = props;
    const [qualifier, setQualifier] = useState(row?.packSizeUnitCode ?? "");

    return (
      <DRxSelectStyle>
        <DRxSelect2
          name="qualifier"
          id="Qualifier"
          options={
            AllDropdwonsState?.qtyQualifiersOption ?? [{ label: "", value: "" }]
          }
          label="Qualifier"
          onChange={(e: any, opt: any) => {
            setQualifier(e.target.value);
            row.packSizeUnitCode = e.target.value;
            row.dosageForm = opt.props.children;
          }}
          value={qualifier}
        />
      </DRxSelectStyle>
    );
  };

  const getDrugSearch = async (drugNameDebounceValue: any) => {
    try {
      setLoading(true);
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("pageNumber", `${page}`);
      params.append("drugType", drugType);
      params.append("drugName", drugNameDebounceValue);
      const result = await FavoriteDrugSearchWithDrugName(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setMessage("");
        setLoading(false);
        setError(false);
      } else {
        setData([]);
        setLoading(false);
        setError(false);
        setMessage(result?.data?.digitalRxStatusMessage);
      }
    } catch (err) {
      setData([]);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    if (drugNameDebounceValue) {
      getDrugSearch(drugNameDebounceValue);
    }
  }, [page, drugType, drugNameDebounceValue]);

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );
  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  const addToPracticeList = async () => {
    try {
      const selectedRows = data[0]?.items?.filter((row: any) =>
        selectionData.includes(row.drugId)
      );
      const bodyData = {
        favoriteDrugFormList: selectedRows?.map((each: any) => ({
          doctorId: doctorId,
          drugId: each?.drugId,
          drugName: each?.drugName,
          strength: each?.strength,
          strengthUnit: each?.strengthUnit,
          route: each?.route,
          dosageForm: each?.dosageForm,
          formularyStatus: each?.formularyStatus,
          sig: each?.sig,
          refills: each?.refills,
          quantity: each?.quantity,
          packSizeUnitCode: each?.packSizeUnitCode,
        })), //selectionData,
      };
      const result = await AddToPracticeList(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHideAddFavDrugPopupClick();
          props.fetchApi();
        }, 1000);
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const addToPhysicianList = async () => {
    try {
      const selectedRows = data[0]?.items?.filter((row: any) =>
        selectionData.includes(row.drugId)
      );
      const bodyData = {
        favoriteDrugFormList: selectedRows?.map((each: any) => ({
          doctorId: doctorId,
          drugId: each?.drugId,
          drugName: each?.drugName,
          strength: each?.strength,
          strengthUnit: each?.strengthUnit,
          route: each?.route,
          dosageForm: each?.dosageForm,
          formularyStatus: each?.formularyStatus,
          sig: each?.sig,
          refills: each?.refills,
          quantity: each?.quantity,
          packSizeUnitCode: each?.packSizeUnitCode,
        })),
      };
      const result = await AddToPhysicianList(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHideAddFavDrugPopupClick();
          props.fetchApi();
        }, 1000);
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  return (
    <>
      <Grid container xs={12}>
        <Grid item xs={12} md={5}>
          <InputBoxStyle style={{ margin: 0 }}>
            <Typography
              component="label"
              color={greyColor}
              variant="body2"
              htmlFor="drugname"
            >
              Drug Name
              <Typography component="span" color={warnColor} variant="body1">
                *
              </Typography>
            </Typography>
            <Box>
              <TextField
                id="drugname"
                name="DrugName"
                type={"search"}
                variant="outlined"
                placeholder="Enter Drug Name"
                onChange={(e) => {
                  setDrugNameInput(e.target.value);
                }}
              />
              {message && (
                <Typography color={"error"} variant="body2">
                  {message}
                </Typography>
              )}
            </Box>
          </InputBoxStyle>{" "}
          <InputBoxStyle style={{ margin: "10px 0 0 0 " }}>
            <Typography component="label" color={greyColor} variant="body2">
              Drug Type:
            </Typography>
            <Box>
              <DRxSelectStyle className="w-auto">
                <DRxSelect2
                  id="dtype"
                  options={[
                    { label: "All", value: "All" },
                    { label: "Generic", value: "Generic" },
                    { label: "Branded", value: "Branded" },
                  ]}
                  name="drugType"
                  onChange={(e: any, opt: any) => {
                    setDrugType(opt.props.value);
                  }}
                  value={drugType}
                />
              </DRxSelectStyle>
            </Box>
          </InputBoxStyle>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              columnGap: 10,
              height: 40,
            }}
          >
            <Typography component="span" variant="body2">
              Selected ({selectionData?.length})
            </Typography>
          </Box>
        </Grid>
        {data[0]?.items && (
          <Grid item xs={12} md={4}>
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 5,
              }}
            >
              <YSButton
                onClick={() => {
                  addToPhysicianList();
                }}
                className=""
                children={"Add to Physician List"}
                size={"medium"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
              <YSButton
                onClick={() => {
                  addToPracticeList();
                }}
                className=""
                children={"Add to Practice List"}
                size={"medium"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </Box>
          </Grid>
        )}
      </Grid>{" "}
      <Grid
        container
        item
        xs={12}
        alignItems="center"
        justifyContent="center"
        padding={"10px"}
        borderRadius={"8px"}
        style={{ marginTop: 10 }}
      >
        <Grid item xs={12}>
          {" "}
          <DataGridListStyle>
            <DataGrid
              columns={columnsAddNewFavDrug}
              rows={data[0]?.items ?? []}
              headerHeight={36}
              paginationMode="server"
              sortingOrder={["desc", "asc"]}
              autoHeight
              rowHeight={40}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              checkboxSelection
              getRowId={(row) => row.drugId ?? uuid()}
              loading={loading}
              components={{
                NoRowsOverlay: NoRecords,
                NoResultsOverlay: NoRecords,
                ErrorOverlay: ErrorOverlay,
              }}
              error={error || undefined}
              page={page}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              onPageChange={(newPage) => {
                setPage(newPage);
              }}
              rowCount={rowCountState}
              onSelectionModelChange={(ids: any) => {
                setSelectionData(ids);
              }}
            />
          </DataGridListStyle>
        </Grid>
      </Grid>{" "}
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
